import React, { useMemo } from "react";
import { useGetWeeklyDetails } from "../../Controllers/DashboardController";
import DoughnutChart from "../DoughnutChart";
import CircularSkeletonLoader from "../SkeletonLoaders/CircularSkeletonLoader";
import MultiLineSkeletonLoader from "../SkeletonLoaders/MultiLineSkeletonLoader";

const PowerScoresCard = () => {
  const { data, isLoading, isError } = useGetWeeklyDetails();
  const powerScores = data?.weeklyDetails || null;

  const chartData = useMemo(
    () => [
      {
        label: "Goals",
        data: [
          powerScores?.goals,
          powerScores?.total_goals
            ? powerScores?.total_goals - powerScores?.goals
            : 1,
        ],
        backgroundColor: ["#5CE0A0", "#1C2934"],
        borderWidth: 0,
        borderColor: "transparent",
        circumference: 360,
        rotation: 85,
        weight: 4,
        borderRadius: [20, 20],
        cutout: "87.34%",
      },
      {
        label: "Tasks",
        data: [
          powerScores?.tasks,
          powerScores?.total_task
            ? powerScores?.total_task - powerScores?.tasks
            : 1,
        ],
        backgroundColor: ["#F5CA41", "#1C2934"],
        borderWidth: 0,
        borderColor: "transparent",
        circumference: 360,
        weight: 2,
        rotation: 100,
        borderRadius: [20, 20],
        cutout: "75.26%",
      },
      {
        label: "Habit",
        data: [
          powerScores?.habits,
          powerScores?.total_habit
            ? powerScores?.total_habit - powerScores?.habits
            : 1,
        ],
        backgroundColor: ["#66BAFF", "#1C2934"],
        borderWidth: 0,
        borderColor: "transparent",
        circumference: 360,
        rotation: 110,
        weight: 1.2,
        borderRadius: [20, 20],
        cutout: "64.7%",
      },
      {
        label: "Journal",
        data: [
          powerScores?.journals,
          powerScores?.total_journals
            ? powerScores?.total_journals - powerScores?.journals
            : 1,
        ],
        backgroundColor: ["#E6F4FF", "#1C2934"],
        borderWidth: 0,
        borderColor: "transparent",
        circumference: 360,
        rotation: 110,
        weight: 1,
        borderRadius: [20, 20],
        cutout: "55%",
      },
    ],
    [powerScores],
  );

  if (isError) return null;

  return (
    <div className="col-lg-12 col-xl-4">
      <div
        className="journal-card metric-card power-scores-card"
        style={{ height: "100%" }}
      >
        <h3 className="h6 mb-3">Power Scores</h3>
        {isLoading ? (
          <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center align-items-center">
            <CircularSkeletonLoader size="157px" />
            <MultiLineSkeletonLoader
              lines={4}
              widths={["140px", "120px", "160px", "130px"]}
            />
          </div>
        ) : (
          <div className="score-section d-flex flex-column flex-sm-row gap-3 gap-sm-4 justify-content-center align-items-center">
            <div className="chart-container">
              <DoughnutChart datasets={chartData} width={157} height={157} />
              <div className="score-value">
                <span className="">{powerScores?.average}</span>
              </div>
            </div>

            <div className="score-legend">
              <div className="legend-item">
                <span
                  className="legend-color"
                  style={{ background: "#e6f4ff" }}
                ></span>
                <span> Journal ({powerScores?.journals})</span>
              </div>
              <div className="legend-item">
                <span
                  className="legend-color"
                  style={{ background: "#66baff" }}
                ></span>
                <span className="dashboard-legend-text">
                  Habit ({powerScores?.habits})
                </span>
              </div>
              <div className="legend-item">
                <span
                  className="legend-color"
                  style={{ background: "#f5ca41" }}
                ></span>
                <span className="dashboard-legend-text">
                  Tasks ({powerScores?.tasks})
                </span>
              </div>
              <div className="legend-item">
                <span
                  className="legend-color"
                  style={{ background: "#5ce0a0" }}
                ></span>
                <span className="dashboard-legend-text">
                  Goals ({powerScores?.goals})
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PowerScoresCard;
